/* Strange require - dependency issue? */
const history = require("history")

export default history.createBrowserHistory({
})



// WEBPACK FOOTER //
// ./src/history.js